<script setup lang="ts">
defineOptions({
	name: 'DataSharingSection',
})

const { t: $t, locale } = useI18n()
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-material-symbols:person-outline-rounded"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('Data Sharing with Third Parties') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p>
				{{
					$t(
						`Users' Personal Data collected through the Platform is not shared with third parties without their consent, except in cases where such transmission or communication is necessary to fulfil Gaveta Decimal’s legitimate interests, to perform a contract entered into with Users, to take steps at the request of the Data Subject prior to entering into a contract, or where necessary to meet a legal obligation to which Gaveta Decimal is subject`,
					)
				}}.
			</p>

			<p>
				{{
					$t(
						`Accordingly, Gaveta Decimal may need to communicate or provide access to Users' Personal Data to third parties collaborating with it, primarily to ensure the proper operation and security of all services available on the Platform. These third parties may include external consultants, cooperation partners, and information technology support services. Gaveta Decimal ensures that each of these third parties upholds the confidentiality of Personal Data by entering into Data Processing Agreements with them`,
					)
				}}.
			</p>

			<p>
				{{
					$t(
						'Our website may contain links to external sites. We are not responsible for the privacy practices or content of those external sites',
					)
				}}.
			</p>

			<p>
				{{
					$t(
						`Furthermore, as previously outlined, Gaveta Decimal may share Users' Personal Data with third parties under specific conditions where there is a good faith belief that it is necessary for the following purposes`,
					)
				}}{{ locale === 'fr' ? ' :' : ':' }}
			</p>
			<ul class="list-disc pl-7 space-y-2.5">
				<li>{{ $t('Compliance with applicable laws or responding to judicial orders') }}.</li>

				<li>
					{{
						$t(
							'Responding to requests from public or governmental authorities, particularly for national security or law enforcement purposes',
						)
					}}.
				</li>

				<li>
					{{
						$t(
							'Safeguarding the vital interests of Users, customers, or other third parties. This includes efforts to prevent spam, deter fraudulent activities related to our products, and avert potential loss of life or serious injury',
						)
					}}.
				</li>

				<li>
					{{
						$t(
							'Operating and maintaining the security and integrity of the Platform, including the prevention or cessation of any attacks on Gaveta Decimal’s computer systems or networks',
						)
					}}.
				</li>

				<li>{{ $t('Protecting Gaveta Decimal’s rights, interests, or property') }}.</li>

				<li>{{ $t('Enforcing Gaveta Decimal’s Terms & Conditions') }}.</li>
			</ul>

			<p>
				{{
					$t(
						'Additionally, Gaveta Decimal may use and share aggregated non-personal information with Third Parties for marketing, advertising, and analytics purposes',
					)
				}}.
			</p>
		</div>
	</section>
</template>
